import React from 'react';
import { QuoteData } from '../../types';
import { ProposalHeader } from './ProposalHeader';
import { KeyStats } from './KeyStats';
import { LoanComparison } from './LoanComparison';
import { EquityBreakdown } from './EquityBreakdown';
import { LoanDetails } from './LoanDetails';
import { ClosingTimeline } from './ClosingTimeline';
import { ProposalFooter } from './ProposalFooter';
import { ArrowLeft } from 'lucide-react';
interface ProposalViewProps {
  data: QuoteData;
  onBack: () => void;
}
export function ProposalView({
  data,
  onBack
}: ProposalViewProps) {
  return <div className="max-w-6xl mx-auto p-4 md:p-8" data-id="element-141">
      {/* Top Navigation */}
      <div className="mb-6 flex justify-between items-center" data-id="element-142">
        <button onClick={onBack} className="flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-143">
          <ArrowLeft className="w-4 h-4" data-id="element-144" />
          Back to Edit
        </button>
        <div className="text-sm text-gray-400" data-id="element-145">
          Generated for {data.borrowerFirstName}
        </div>
      </div>

      {/* Dark Proposal Canvas */}
      <div className="bg-charcoal-900 rounded-[2rem] p-4 md:p-8 shadow-2xl border border-white/5 relative overflow-hidden text-white font-light" data-id="element-146">
        {/* Confidential Watermark */}
        <div className="absolute top-12 right-12 text-[10px] font-bold tracking-[0.3em] text-white/5 select-none pointer-events-none z-0 border border-white/5 px-4 py-2 rounded-sm rotate-12" data-id="element-147">
          CONFIDENTIAL
        </div>

        <div className="space-y-8 relative z-10" data-id="element-148">
          {/* Header */}
          <ProposalHeader data={data} data-id="element-149" />

          {/* Key Stats Row */}
          <KeyStats data={data} data-id="element-150" />

          {/* Main Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-151">
            <div className="space-y-8" data-id="element-152">
              <LoanComparison data={data} data-id="element-153" />
              <EquityBreakdown data={data} data-id="element-154" />
            </div>
            <div className="space-y-8" data-id="element-155">
              <LoanDetails data={data} data-id="element-156" />
              <div className="bg-charcoal-800 rounded-2xl border border-white/10 p-6 md:p-8" data-id="element-157">
                <ClosingTimeline data-id="element-158" />
              </div>
            </div>
          </div>

          {/* Footer */}
          <ProposalFooter data={data} data-id="element-159" />
        </div>
      </div>
    </div>;
}